;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="7020673a-6308-41ac-b010-bf08fceef2da",e._sentryDebugIdIdentifier="sentry-dbid-7020673a-6308-41ac-b010-bf08fceef2da")}catch(e){}}();
"use strict";
(self["webpackChunkretino"] = self["webpackChunkretino"] || []).push([[961],{

/***/ 64722:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   Kv: () => (/* binding */ ApiProvider)
/* harmony export */ });
/* unused harmony export ApiContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41906);
/* harmony import */ var stores_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9432);
/* harmony import */ var _codegen_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13060);
/* harmony import */ var _middlewares__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11031);





const ApiContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useApi = () => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .useContextSafe */ .qr)(ApiContext);
function ApiProvider(_ref) {
  let {
    children
  } = _ref;
  const history = (0,stores_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useHistory */ .W6)();
  const [api] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => new _codegen_api__WEBPACK_IMPORTED_MODULE_3__/* .ApiClient */ .OWz({
    baseUrl: "".concat(window.location.origin, "/api/internal/private"),
    middlewares: [new _middlewares__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A.AddCsrfHeaderMiddleware(), new _middlewares__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A.TrackRequestIdMiddleware(), new _middlewares__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A.HandleErrorsMiddleware(history, window.appState.lang)],
    getHeaders: () => ({
      'Accept-Language': window.appState.lang,
      'Content-Type': 'application/json',
      'X-Retino-Frontend': window.appState.bundleHash
    })
  }));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ApiContext.Provider, {
    value: api
  }, children);
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useApi);

/***/ }),

/***/ 57961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ extractCodeError)
/* harmony export */ });
async function extractCodeError(error, fallbackMessage) {
  if (error && typeof error === 'object' && 'response' in error) {
    const data = await error.response.json();
    return (data === null || data === void 0 ? void 0 : data.code) || (data === null || data === void 0 ? void 0 : data.error) || gettext('Invalid code');
  }
  return fallbackMessage;
}

/***/ }),

/***/ 73678:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export countryFlagUrl */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);



// Reuses the flag images django-countries already ships and the Django-rendered tables
// already draw (templates/ui/country_flag.html) — no new dependency.
function countryFlagUrl(country) {
  if (!country || country.length !== 2) return null;
  return "".concat(window.appState.baseStaticUrl, "flags/").concat(country.toLowerCase(), ".gif");
}
function CountryFlag(_ref) {
  let {
    country,
    className = 'h-3 w-4'
  } = _ref;
  const [failed, setFailed] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const url = countryFlagUrl(country);
  if (!url || failed) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('inline-block shrink-0 rounded-sm bg-gray-100', className)
    });
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: url,
    alt: "",
    title: country === null || country === void 0 ? void 0 : country.toUpperCase(),
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('inline-block shrink-0 rounded-sm', className),
    onError: () => setFailed(true)
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CountryFlag);

/***/ }),

/***/ 31528:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64722);
/* harmony import */ var stores_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25193);
/* harmony import */ var stores_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9432);
/* harmony import */ var ui_brand_components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89939);
/* harmony import */ var ui_brand_components_TextInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76776);






function CreateCompany(_ref) {
  let {
    onCreate
  } = _ref;
  const api = (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Ay)();
  const [name, setName] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('');
  const [language, setLanguage] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('cs');
  const [handleCreateCompany, isLoading] = (0,stores_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAsyncFunction */ .m_)(async () => {
    const createdCompany = await api.CompanyCreateCompanyApi.create({
      request: {
        name: {
          [language]: name
        },
        language: language
      }
    });
    onCreate(createdCompany.id);
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("form", {
    className: "flex flex-col gap-5",
    onSubmit: event => {
      event.preventDefault();
      handleCreateCompany();
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_brand_components_TextInput__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A, {
    label: pgettext('company', 'Account name'),
    required: true,
    autoFocus: true,
    name: "account-name",
    autoComplete: "organization",
    value: name,
    onChange: setName
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("fieldset", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("legend", {
    className: "mb-2 text-base font-semibold text-retino-darkviolet sm:text-sm"
  }, gettext('Company language')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex flex-wrap gap-4"
  }, stores_constants__WEBPACK_IMPORTED_MODULE_2__/* .supportedLanguages */ .Uv.map(lang => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
    key: lang,
    className: "flex items-center gap-2 text-sm text-retino-darkviolet"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    type: "radio",
    name: "language",
    checked: language === lang,
    onChange: () => setLanguage(lang),
    className: "accent-retino-darkviolet"
  }), stores_constants__WEBPACK_IMPORTED_MODULE_2__/* .allLanguagesLocalised */ .P8[lang])))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_brand_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, {
    type: "submit",
    variant: "primary",
    fullWidth: true,
    loading: isLoading
  }, gettext('Create account')));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CreateCompany);

/***/ }),

/***/ 43453:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function SupportNote() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "mt-8 text-center text-base leading-normal text-retino-darkgrey sm:text-sm"
  }, gettext('If you encounter any problems, please do not hesitate to contact our support at'), ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "mailto:support@retino.com",
    className: "font-semibold text-brand-500"
  }, "support@retino.com"), ".");
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SupportNote);

/***/ }),

/***/ 91431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93893);

const appRoutes = {
  demoKrystofee: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/demo-krystofee/'),
  tickets: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tickets/'),
  ticketsDetailTicketDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tickets/detail/:ticketId/'),
  ticketsNew: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tickets/new/'),
  ticketsTicketIdProductsFiles: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tickets/:ticketId/products-files'),
  products: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/products/'),
  communication: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/communication/'),
  customers: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/customers/'),
  customersCustomerDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/customers/:customerId/'),
  settings: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/'),
  settingsUpgrade: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/upgrade/'),
  settingsUpgradeWelcome: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/upgrade/welcome/'),
  settingsAutomationTriggers: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/automation/triggers/'),
  settingsAutomationTriggersDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/automation/triggers/:pk/'),
  settingsAutomationTriggersCreate: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/automation/triggers/create/'),
  settingsAutomationTriggersInactive: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/automation/triggers/inactive/'),
  settingsBadge: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/badge/'),
  settingsBillingOverview: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/billing/overview/'),
  settingsCannedReplies: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/canned-replies/'),
  settingsCannedRepliesDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/canned-replies/:pk/'),
  settingsCannedRepliesCreate: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/canned-replies/create'),
  settingsCompany: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/company/'),
  settingsMcp: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/mcp/'),
  settingsBilling: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/billing/'),
  settingsCustomField: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/custom-field/'),
  settingsTicketCustomFieldDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/ticket-custom-field/:pk/'),
  settingsTicketCustomFieldCreate: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/ticket-custom-field/create/'),
  settingsProductCustomFieldDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/product-custom-field/:pk/'),
  settingsProductCustomFieldCreate: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/product-custom-field/create/'),
  settingsDocuments: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/documents/'),
  settingsDocumentsTicketTypeCreate: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/documents/:ticketType/create/'),
  settingsDocumentsTicketTypeDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/documents/:ticketType/:pk/'),
  settingsEmailing: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/emailing/'),
  settingsEmailingDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/emailing/:pk/'),
  settingsOrders: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/orders/'),
  settingsProcesses: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/processes/'),
  settingsRefunds: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/refunds/'),
  settingsRefundOptions: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/refund-options/'),
  settingsCreditNotes: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/credit-notes/'),
  settingsExchanges: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/exchanges/'),
  settingsSubscriptionsUnpaidInvoices: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/subscriptions/unpaid-invoices/'),
  settingsBillingDisabledVerifyPayment: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/billing/disabled-verify-payment/'),
  settingsTags: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/tags/'),
  settingsTagsDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/tags/:pk'),
  settingsTeam: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/team/'),
  settingsTicketTypes: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/ticket-types/'),
  settingsTicketTypesDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/ticket-types/:pk/'),
  settingsTicketTypesFormPkForm: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/ticket-types-form/:pk/form/'),
  settingsTicketViews: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/ticket-views/'),
  settingsTicketViewsDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/ticket-views/:pk/'),
  settingsTicketViewsCreate: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/ticket-views/create/'),
  settingsTransportCustomerPaid: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/transport/customer-paid/'),
  settingsTransportShipping: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/transport/shipping/'),
  settingsUser: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/user/'),
  settingsApiV2: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/api-v2/'),
  settingsApiV2Webhooks: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/api-v2/webhooks/'),
  settingsApiV2WebhooksDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/api-v2/webhooks/:pk/'),
  settingsShippingIntegrations: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/integrations/'),
  settingsShippingContract: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/contract/'),
  settingsShippingContractDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/contract/:pk/'),
  settingsShippingAddresses: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/addresses/'),
  settingsShippingCustomerPaid: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/customer-paid/'),
  settingsShippingShopPaid: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/shop-paid/'),
  settingsShippingShippingContractsCreate: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/shipping-contracts-create/'),
  settingsShippingShippingContractsDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/shipping-contracts/:pk/'),
  settingsShippingAutomation: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/automation/'),
  settingsMarketplace: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/marketplace/'),
  settingsMarketplaceInstalledPluginDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/marketplace/installed-plugin/:pk/?ticket_type=:ticketType'),
  settingsPortal: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/portal/'),
  settingsPortalIntegration: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/portal/integration/'),
  settingsShippingPortal: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/portal/'),
  settingsShippingPortalIntegration: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/shipping/portal/integration/'),
  settingsWorkflowsFlows: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/workflows/flows/'),
  notifications: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/notifications/'),
  documentsIframeDocumentPreviewDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/documents/iframe/document-preview/:pk/'),
  stats: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/stats/'),
  statsRating: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/stats/rating/'),
  statsProducts: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/stats/products/'),
  statsReturnRate: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/stats/return-rate/'),
  onboardingPlatformIntegrationPlatformIntegrationIdConnectAccount: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/onboarding/platform-integration/:platformIntegrationId/connect-account/'),
  orders: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/orders/'),
  refunds: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/refunds/'),
  shipping: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/shipping/'),
  shippingNewShopPaidUsageExport: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/shipping-new/shop-paid/usage-export'),
  shippingPortalShipping: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/shipping-portal/shipping'),
  activity: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/activity/'),
  index: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/'),
  demo: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/demo/'),
  search: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/search/'),
  tracking: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/'),
  trackingShipping: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/shipping/'),
  trackingIssues: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/issues/'),
  trackingAnalytics: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/analytics/'),
  trackingSettingsProviders: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/providers/'),
  trackingSettingsOrders: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/orders/'),
  trackingSettingsOrdersCopIdStatusMapping: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/orders/:copId/status-mapping/'),
  trackingSettingsTags: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/tags/'),
  trackingSettingsIssueTypes: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/issue-types/'),
  trackingSettingsCarrierTransitTimes: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/carrier-transit-times/'),
  trackingSettingsTrackntraceIntegrations: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/trackntrace/integrations/'),
  trackingSettingsCostAnalysis: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/cost-analysis/'),
  trackingSettingsWebhooks: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/webhooks/'),
  trackingSettingsAutomation: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/automation/'),
  trackingSettingsEmailing: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/emailing/'),
  trackingSettingsEmailDomains: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/email-domains/'),
  trackingSettingsEmailDomainsDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/email-domains/:pk/'),
  trackingSettingsEmailDomainsPkRefresh: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/email-domains/:pk/refresh/'),
  trackingSettingsNotifications: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/tracking/settings/notifications/'),
  flows: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/flows/'),
  authTwoFactorRequired: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/auth/two-factor-required/'),
  settingsBranches: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/settings/branches/')
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (appRoutes);

/***/ }),

/***/ 32708:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93893);

const authRoutes = {
  companyLaunchpad: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/company/launchpad/'),
  companySetActiveAccountCompanyDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/company/set-active-account/:companyId/'),
  companyInvitationAcceptInvitationDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/company/invitation-accept/:invitationId/'),
  companyInvitationExpired: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/company/invitation-expired/'),
  authLogin: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/auth/login/'),
  authLogout: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/auth/logout/'),
  authPasswordReset: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/auth/password_reset/'),
  authResetUidb64Token: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/auth/reset/:uidb64/:token/'),
  onboarding: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/onboarding/'),
  onboardingPlatformIntegrationPlatformIntegrationDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/onboarding/platform-integration/:platformIntegrationId/'),
  onboardingPlatformIntegrationPlatformIntegrationIdCompleted: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/onboarding/platform-integration/:platformIntegrationId/completed/'),
  onboardingShoptetDisplayEmailPlatformIntegrationDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/onboarding/shoptet/display-email/:platformIntegrationId/')
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (authRoutes);

/***/ }),

/***/ 44718:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export selectUpsellPrice */
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27813);
/* harmony import */ var _featureDefinitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38230);
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }



// Picks the price to advertise for a target tier. During the Pricing 2026 transition both the
// old TIERED and the new PER_UNIT row may be public on the same tier level — prefer the new one.
// Never fall back across tiers: buying a lower tier would not unlock the requested feature.
function selectUpsellPrice(prices, currency, targetTierLevel) {
  let productType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'MANAGER';
  const productPrices = prices.filter(p => p.product.internal_type === productType && p.currency === currency && p.tier_level > 0);
  const exactMatches = productPrices.filter(p => p.tier_level === targetTierLevel);
  return exactMatches.find(p => p.billing_scheme === 'PER_UNIT') || exactMatches[0] || null;
}
let FeatureUpsellStore = (_class = class FeatureUpsellStore {
  constructor() {
    _initializerDefineProperty(this, "isOpen", _descriptor, this);
    _initializerDefineProperty(this, "feature", _descriptor2, this);
    _initializerDefineProperty(this, "prices", _descriptor3, this);
    _initializerDefineProperty(this, "isPriceLoading", _descriptor4, this);
    this.currency = null;
    _initializerDefineProperty(this, "loadPrices", _descriptor5, this);
    (0,mobx__WEBPACK_IMPORTED_MODULE_1__/* .makeObservable */ .Gn)(this);
  }

  // Price for the feature currently shown in the upsell modal.
  get upsellPrice() {
    if (!this.feature) return null;
    const productType = this.feature.startsWith('tracking_') ? 'TRACKING' : 'MANAGER';
    return this.priceForTier((0,_featureDefinitions__WEBPACK_IMPORTED_MODULE_0__/* .getFeatureTargetTierLevel */ .Ql)(this.feature), productType);
  }
  priceForTier(tierLevel) {
    let productType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MANAGER';
    if (!this.prices || !this.currency) return null;
    return selectUpsellPrice(this.prices, this.currency, tierLevel, productType);
  }
  open(feature) {
    this.feature = feature;
    this.isOpen = true;
  }
  close() {
    this.isOpen = false;
    this.feature = null;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isOpen", [mobx__WEBPACK_IMPORTED_MODULE_1__/* .observable */ .sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "feature", [mobx__WEBPACK_IMPORTED_MODULE_1__/* .observable */ .sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "prices", [mobx__WEBPACK_IMPORTED_MODULE_1__/* .observable */ .sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isPriceLoading", [mobx__WEBPACK_IMPORTED_MODULE_1__/* .observable */ .sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "upsellPrice", [mobx__WEBPACK_IMPORTED_MODULE_1__/* .computed */ .EW], Object.getOwnPropertyDescriptor(_class.prototype, "upsellPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "open", [mobx__WEBPACK_IMPORTED_MODULE_1__/* .action */ .XI], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [mobx__WEBPACK_IMPORTED_MODULE_1__/* .action */ .XI], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "loadPrices", [mobx__WEBPACK_IMPORTED_MODULE_1__/* .action */ .XI], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return async (api, billingCurrency) => {
      if (this.prices || this.isPriceLoading) return;
      this.currency = billingCurrency;
      this.isPriceLoading = true;
      try {
        this.prices = await api.SubscriptionsPriceApi.list();
      } finally {
        this.isPriceLoading = false;
      }
    };
  }
})), _class);
const featureUpsellStore = new FeatureUpsellStore();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (featureUpsellStore);

/***/ }),

/***/ 33835:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function AuthCard(_ref) {
  let {
    title,
    subtitle,
    eyebrow,
    wide = false,
    children
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('mx-auto mt-6 rounded-3xl bg-white/70 p-0 sm:p-2 lg:mt-12', wide ? 'max-w-[840px]' : 'max-w-[456px]')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "rounded-3xl bg-white px-4 py-6 sm:rounded-2xl sm:px-6 sm:py-8 lg:p-8"
  }, eyebrow && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-center text-[13px] font-semibold uppercase tracking-widest text-retino-darkviolet/70"
  }, eyebrow), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('text-balance text-center font-semibold leading-tight text-retino-darkviolet', {
      'mt-4': eyebrow,
      'text-2xl lg:text-[28px]': !wide,
      'text-[28px] lg:text-[32px]': wide
    })
  }, title), subtitle && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "mt-3 text-center text-base leading-snug text-black"
  }, subtitle), children));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AuthCard);

/***/ }),

/***/ 7426:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ components_AuthShell)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./react/layouts/main-sidebar/LogoIcon.tsx
var LogoIcon = __webpack_require__(56858);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js
var menu = __webpack_require__(37096);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(46942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./react/components/CountryFlag.tsx
var CountryFlag = __webpack_require__(73678);
// EXTERNAL MODULE: ./react/ui-brand/languages.ts
var languages = __webpack_require__(28335);
;// ./react/ui-brand/components/LanguageSelector.tsx






// Only for pages under i18n_patterns: the language is the first path segment.
const urlInLanguage = code => {
  const {
    pathname,
    search
  } = window.location;
  const segments = pathname.split('/');
  segments[1] = code;
  return "".concat(segments.join('/')).concat(search);
};
function LanguageSelector() {
  const selected = (0,languages/* currentLanguage */.aS)();
  if (!selected) return null;
  return /*#__PURE__*/react.createElement(menu/* Menu */.W, {
    as: "div",
    className: "relative"
  }, /*#__PURE__*/react.createElement(menu/* Menu */.W.Button, {
    className: "flex min-h-12 items-center gap-2 rounded-lg p-3 text-sm font-semibold text-retino-darkviolet transition-colors hover:bg-white/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-retino-darkviolet",
    "aria-label": gettext('Change language')
  }, /*#__PURE__*/react.createElement(CountryFlag/* default */.A, {
    country: selected.country,
    className: "h-4 w-[22px] rounded-sm"
  }), selected.code.toUpperCase()), /*#__PURE__*/react.createElement(menu/* Menu */.W.Items, {
    className: "absolute right-0 top-full z-10 mt-2 flex w-52 flex-col rounded-2xl bg-white p-2 shadow-lg outline-none"
  }, languages/* LANGUAGES */.Yj.map(language => /*#__PURE__*/react.createElement(menu/* Menu */.W.Item, {
    key: language.code
  }, _ref => {
    let {
      active
    } = _ref;
    return /*#__PURE__*/react.createElement("a", {
      href: urlInLanguage(language.code),
      className: classnames_default()('flex items-center gap-3 rounded-lg px-3 py-2 text-base text-retino-darkviolet', active && 'bg-retino-beige')
    }, /*#__PURE__*/react.createElement(CountryFlag/* default */.A, {
      country: language.country,
      className: "h-4 w-[22px] rounded-sm"
    }), language.label);
  }))));
}
/* harmony default export */ const components_LanguageSelector = (LanguageSelector);
;// ./react/ui-brand/components/AuthShell.tsx



function AuthShell(_ref) {
  let {
    languageSelector = true,
    children
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex min-h-dvh flex-col bg-retino-beige font-lexend antialiased"
  }, /*#__PURE__*/react.createElement("header", {
    className: "p-4 lg:px-8"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mx-auto flex w-full max-w-screen-xl items-center justify-between"
  }, /*#__PURE__*/react.createElement("a", {
    href: "https://www.retino.com",
    className: "flex min-h-12 items-center text-retino-darkviolet",
    "aria-label": "Retino"
  }, /*#__PURE__*/react.createElement("span", {
    className: "block w-32 lg:w-40"
  }, /*#__PURE__*/react.createElement(LogoIcon/* default */.A, null))), languageSelector && /*#__PURE__*/react.createElement(components_LanguageSelector, null))), /*#__PURE__*/react.createElement("main", {
    className: "mx-auto w-full max-w-screen-xl grow px-4 lg:px-8"
  }, children), /*#__PURE__*/react.createElement("footer", {
    className: "px-4 py-8 text-center text-base text-retino-darkgrey sm:text-[13px]"
  }, "\xA9 2017\u2013", new Date().getFullYear(), " Retino.cz s.r.o."));
}
/* harmony default export */ const components_AuthShell = (AuthShell);

/***/ }),

/***/ 89939:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ui_brand_components_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50530);



function Button(_ref) {
  let {
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    arrow = false,
    disabled = false,
    loading = false,
    type = 'button',
    onClick,
    children,
    className
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    // eslint-disable-next-line react/button-has-type
    type: type,
    disabled: disabled || loading,
    onClick: onClick,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('inline-flex items-center justify-center gap-2 rounded-full font-lexend font-semibold leading-snug transition-opacity focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-retino-darkviolet', {
      'bg-retino-lightviolet text-retino-darkviolet hover:opacity-90': variant === 'primary',
      'border-[1.5px] border-retino-darkviolet bg-transparent text-retino-darkviolet hover:bg-retino-darkviolet/10': variant === 'outline',
      'text-retino-darkviolet/70 hover:text-retino-darkviolet': variant === 'secondary',
      'px-6 py-4 text-xl': size === 'lg',
      'px-6 py-2 text-lg': size === 'md',
      'px-4 py-2 text-base': size === 'sm',
      'w-full': fullWidth,
      'cursor-not-allowed opacity-40 hover:opacity-40': disabled
    }, className)
  }, loading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_brand_components_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
    size: "sm"
  }) : children, arrow && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    className: "size-4",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5 12h14M13 6l6 6-6 6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Button);

/***/ }),

/***/ 75901:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function FieldLabel(_ref) {
  let {
    htmlFor,
    required = false,
    optionalHint,
    children
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
    htmlFor: htmlFor,
    className: "mb-2 block text-base font-semibold text-retino-darkviolet sm:text-sm"
  }, children, required && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-red-600"
  }, "*"), optionalHint && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "font-normal text-retino-darkgrey"
  }, " ", optionalHint));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FieldLabel);

/***/ }),

/***/ 50530:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


const SIZES = {
  sm: 'size-5',
  md: 'size-8',
  lg: 'size-12'
};
function Loader(_ref) {
  let {
    size = 'md'
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    role: "status",
    "aria-label": gettext('Loading'),
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('animate-spin text-retino-darkviolet', SIZES[size]),
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9",
    className: "stroke-retino-lightviolet/40",
    strokeWidth: "3.5"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9",
    stroke: "currentColor",
    strokeWidth: "3.5",
    strokeLinecap: "round",
    strokeDasharray: "42 14.5"
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Loader);

/***/ }),

/***/ 76776:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _FieldLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75901);



function TextInput(_ref) {
  let {
    label,
    required = false,
    optionalHint,
    placeholder,
    icon,
    trailing,
    type = 'text',
    autoComplete,
    autoFocus = false,
    value,
    onChange,
    error,
    name
  } = _ref;
  const generatedId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  const inputId = name || generatedId;
  const errorId = "".concat(inputId, "-error");
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "w-full font-lexend"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_FieldLabel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
    htmlFor: inputId,
    required: required,
    optionalHint: optionalHint
  }, label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative"
  }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "pointer-events-none absolute inset-y-0 left-3 flex items-center text-retino-grey"
  }, icon), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    id: inputId,
    name: name,
    type: type,
    autoComplete: autoComplete
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: autoFocus,
    value: value,
    placeholder: placeholder,
    required: required,
    onChange: event => onChange(event.target.value),
    "aria-invalid": Boolean(error),
    "aria-describedby": error ? errorId : undefined,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('h-12 w-full rounded-xl border bg-white px-3 text-sm text-black outline-none transition placeholder:text-retino-grey/70 focus:border-retino-darkviolet focus:ring-2 focus:ring-retino-lightviolet max-sm:text-base', {
      'pl-11': icon,
      'pr-12': trailing,
      'border-red-500': error,
      'border-slate-300': !error
    })
  }), trailing && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "absolute inset-y-0 right-1 flex items-center"
  }, trailing)), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    id: errorId,
    className: "mt-2 text-[13px] leading-snug text-red-600"
  }, error));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TextInput);

/***/ })

}]);